import * as ActionType from "./RedeemType";

const initialState = {
  redeem: [],
};

export const redeemReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_REDEEM:
      return {
        ...state,
        redeem: action.payload,
      };
    case ActionType.GET_ADMIN_REDEEM:
      return {
        ...state,
        redeem: action.payload,
      };
    case ActionType.CREATE_ADMIN_REDEEM:
      return {
        ...state,
        redeem: [action.payload, ...state.redeem],
      };
    case ActionType.ACCEPT_REDEEM:
      return {
        ...state,
        redeem: state.redeem.filter((data) => data._id.toString() !== action.payload.toString()),
      };
    default:
      return state;
  }
};
